import WebMediaRecorder from './WebMediaRecorder';

export default WebMediaRecorder;
